export type ConfirmationObservationBody = {
  processing?: boolean;
  submission?: {
    status?: string;
    message?: string | null;
    amountDueCents?: number;
  };
};

/** Read the parent state from either the confirm response or the GET response. */
export function submissionStatus(body: ConfirmationObservationBody | null): string | null {
  return body?.submission?.status ?? null;
}

/** These states are owned by the durable worker, not by another tap. */
export function isConfirmationInProgress(status: string | null): boolean {
  return status === "confirmation_requested" || status === "processing";
}

/** A terminal worker outcome returns control to an explicit manual retry. */
export function isConfirmationTerminal(status: string | null): boolean {
  return status === "confirmation_failed" || status === "ready";
}

export function confirmationFailureMessage(body: ConfirmationObservationBody | null): string {
  return body?.submission?.message || "We could not finish this confirmation. Try again when you are ready.";
}
